import { createSlice } from '@reduxjs/toolkit';
import { fetchAllMaintenanceAmountReport } from './maintenance.Action';
import { maintenancereportsState , maintenancereports } from './maintenance.Type';


const initialState :maintenancereportsState ={
    maintenancereport : [],
    selectedemployeereport : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
}

const  MaintenanceReportSlice = createSlice ({
    name : 'maintenancereport' ,
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
                               .addCase(fetchAllMaintenanceAmountReport.pending, (state) => {
                                   state.loadingStates.fetchAll = true;
                                   state.errors.fetchAll = undefined;
                               })
                               .addCase(fetchAllMaintenanceAmountReport.fulfilled, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.maintenancereport = action.payload.data;
                               })
                               .addCase(fetchAllMaintenanceAmountReport.rejected, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.errors.fetchAll = action.payload as string;
                               }); 
    }
})

export default  MaintenanceReportSlice.reducer;